var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _taggedTemplateLiteral = require("/workspace/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pageResults = require('graph-results-pager');

var ws = require('isomorphic-ws');

var _require = require('subscriptions-transport-ws'),
    SubscriptionClient = _require.SubscriptionClient;

var _require2 = require('graphql-request'),
    request = _require2.request,
    gql = _require2.gql;

var _require3 = require("date-fns"),
    subWeeks = _require3.subWeeks,
    getUnixTime = _require3.getUnixTime,
    fromUnixTime = _require3.fromUnixTime;

var _require4 = require('./../../constants'),
    graphAPIEndpoints = _require4.graphAPIEndpoints,
    graphWSEndpoints = _require4.graphWSEndpoints,
    TWENTY_FOUR_HOURS = _require4.TWENTY_FOUR_HOURS;

var _require5 = require('./../../utils'),
    timestampToBlock = _require5.timestampToBlock,
    timestampsToBlocks = _require5.timestampsToBlocks,
    blockToTimestamp = _require5.blockToTimestamp;

var _require6 = require('./../exchange/eth'),
    ethPrice = _require6.ethPrice;

module.exports = {
  pair: function pair() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$block, block, _ref$timestamp, timestamp, _ref$pair_address, pair_address, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp, _ref$pair_address = _ref.pair_address, pair_address = _ref$pair_address === void 0 ? undefined : _ref$pair_address;

              if (pair_address) {
                _context.next = 3;
                break;
              }

              throw new Error("sushi-data: Pair address undefined");

            case 3:
              if (!block) {
                _context.next = 7;
                break;
              }

              _context.t0 = block;
              _context.next = 15;
              break;

            case 7:
              if (!timestamp) {
                _context.next = 13;
                break;
              }

              _context.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context.t1 = _context.sent;
              _context.next = 14;
              break;

            case 13:
              _context.t1 = undefined;

            case 14:
              _context.t0 = _context.t1;

            case 15:
              block = _context.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context.next = 19;
              return request(graphAPIEndpoints.exchange, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n                    pair(id: \"", "\", ", ") {\n                        ", "\n                    }\n                }"])), pair_address.toLowerCase(), block, _pairs.properties.toString()));

            case 19:
              result = _context.sent;
              return _context.abrupt("return", _pairs.callback([result.pair])[0]);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  pair24h: function pair24h() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref2, _ref2$block, block, _ref2$timestamp, timestamp, _ref2$pair_address, pair_address, timestampNow, result, result24ago, result48ago, ethPriceUSD, ethPriceUSD24ago;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref2$block = _ref2.block, block = _ref2$block === void 0 ? undefined : _ref2$block, _ref2$timestamp = _ref2.timestamp, timestamp = _ref2$timestamp === void 0 ? undefined : _ref2$timestamp, _ref2$pair_address = _ref2.pair_address, pair_address = _ref2$pair_address === void 0 ? undefined : _ref2$pair_address;

              if (pair_address) {
                _context2.next = 3;
                break;
              }

              throw new Error("sushi-data: Pair address undefined");

            case 3:
              if (!timestamp) {
                _context2.next = 7;
                break;
              }

              _context2.t0 = timestamp;
              _context2.next = 15;
              break;

            case 7:
              if (!block) {
                _context2.next = 13;
                break;
              }

              _context2.next = 10;
              return blockToTimestamp(block);

            case 10:
              _context2.t1 = _context2.sent;
              _context2.next = 14;
              break;

            case 13:
              _context2.t1 = Math.floor(Date.now() / 1000);

            case 14:
              _context2.t0 = _context2.t1;

            case 15:
              timestampNow = _context2.t0;
              timestamp24ago = timestampNow - TWENTY_FOUR_HOURS;
              timestamp48ago = timestamp24ago - TWENTY_FOUR_HOURS;

              if (!timestamp) {
                _context2.next = 24;
                break;
              }

              _context2.next = 21;
              return timestampToBlock(timestamp);

            case 21:
              _context2.t2 = _context2.sent;
              _context2.next = 25;
              break;

            case 24:
              _context2.t2 = block;

            case 25:
              block = _context2.t2;
              _context2.next = 28;
              return timestampToBlock(timestamp24ago);

            case 28:
              block24ago = _context2.sent;
              _context2.next = 31;
              return timestampToBlock(timestamp48ago);

            case 31:
              block48ago = _context2.sent;
              _context2.next = 34;
              return module.exports.pair({
                block: block,
                pair_address: pair_address
              });

            case 34:
              result = _context2.sent;
              _context2.next = 37;
              return module.exports.pair({
                block: block24ago,
                pair_address: pair_address
              });

            case 37:
              result24ago = _context2.sent;
              _context2.next = 40;
              return module.exports.pair({
                block: block48ago,
                pair_address: pair_address
              });

            case 40:
              result48ago = _context2.sent;
              _context2.next = 43;
              return ethPrice({
                block: block
              });

            case 43:
              ethPriceUSD = _context2.sent;
              _context2.next = 46;
              return ethPrice({
                block: block24ago
              });

            case 46:
              ethPriceUSD24ago = _context2.sent;
              return _context2.abrupt("return", _pairs.callback24h([result], [result24ago], [result48ago], ethPriceUSD, ethPriceUSD24ago)[0]);

            case 48:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  pairHourData: function pairHourData() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref3, _ref3$minTimestamp, minTimestamp, _ref3$maxTimestamp, maxTimestamp, _ref3$minBlock, minBlock, _ref3$maxBlock, maxBlock, _ref3$pair_address, pair_address, endTime, time, timestamps, blocks, query, result;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, _ref3$minTimestamp = _ref3.minTimestamp, minTimestamp = _ref3$minTimestamp === void 0 ? undefined : _ref3$minTimestamp, _ref3$maxTimestamp = _ref3.maxTimestamp, maxTimestamp = _ref3$maxTimestamp === void 0 ? undefined : _ref3$maxTimestamp, _ref3$minBlock = _ref3.minBlock, minBlock = _ref3$minBlock === void 0 ? undefined : _ref3$minBlock, _ref3$maxBlock = _ref3.maxBlock, maxBlock = _ref3$maxBlock === void 0 ? undefined : _ref3$maxBlock, _ref3$pair_address = _ref3.pair_address, pair_address = _ref3$pair_address === void 0 ? undefined : _ref3$pair_address;

              if (pair_address) {
                _context3.next = 3;
                break;
              }

              throw new Error("sushi-data: Pair address undefined");

            case 3:
              minTimestamp = minBlock ? blockToTimestamp(minBlock) : minTimestamp;
              maxTimestamp = maxBlock ? blockToTimestamp(maxBlock) : maxTimestamp;
              endTime = maxTimestamp ? fromUnixTime(maxTimestamp) : new Date();
              time = minTimestamp ? minTimestamp : getUnixTime(subWeeks(endTime, 1)); // create an array of hour start times until we reach current hour

              timestamps = [];

              while (time <= getUnixTime(endTime) - 3600) {
                timestamps.push(time);
                time += 3600;
              }

              _context3.next = 11;
              return timestampsToBlocks(timestamps);

            case 11:
              blocks = _context3.sent;
              query = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{\n                ", "\n            }"])), blocks.map(function (block, i) {
                return gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                    timestamp", ": pair(id: \"", "\", block: {number: ", "}) {\n                        ", "\n                }"])), timestamps[i], pair_address.toLowerCase(), block, _pairs.properties.toString());
              }));
              _context3.next = 15;
              return request(graphAPIEndpoints.exchange, query);

            case 15:
              result = _context3.sent;
              result = Object.keys(result).map(function (key) {
                return _objectSpread(_objectSpread({}, result[key]), {}, {
                  timestamp: Number(key.split("timestamp")[1])
                });
              }).sort(function (a, b) {
                return a.timestamp - b.timestamp;
              });
              return _context3.abrupt("return", _pairs.callbackHourData(result));

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  pairDayData: function pairDayData() {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref4, _ref4$minTimestamp, minTimestamp, _ref4$maxTimestamp, maxTimestamp, _ref4$minBlock, minBlock, _ref4$maxBlock, maxBlock, _ref4$pair_address, pair_address;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {}, _ref4$minTimestamp = _ref4.minTimestamp, minTimestamp = _ref4$minTimestamp === void 0 ? undefined : _ref4$minTimestamp, _ref4$maxTimestamp = _ref4.maxTimestamp, maxTimestamp = _ref4$maxTimestamp === void 0 ? undefined : _ref4$maxTimestamp, _ref4$minBlock = _ref4.minBlock, minBlock = _ref4$minBlock === void 0 ? undefined : _ref4$minBlock, _ref4$maxBlock = _ref4.maxBlock, maxBlock = _ref4$maxBlock === void 0 ? undefined : _ref4$maxBlock, _ref4$pair_address = _ref4.pair_address, pair_address = _ref4$pair_address === void 0 ? undefined : _ref4$pair_address;

              if (pair_address) {
                _context4.next = 3;
                break;
              }

              throw new Error("sushi-data: Pair address undefined");

            case 3:
              _context4.t0 = pageResults;
              _context4.t1 = graphAPIEndpoints.exchange;
              _context4.t2 = "\\\"".concat(pair_address.toLowerCase(), "\\\"");
              _context4.t3 = minTimestamp;

              if (_context4.t3) {
                _context4.next = 16;
                break;
              }

              if (!minBlock) {
                _context4.next = 14;
                break;
              }

              _context4.next = 11;
              return blockToTimestamp(minBlock);

            case 11:
              _context4.t4 = _context4.sent;
              _context4.next = 15;
              break;

            case 14:
              _context4.t4 = undefined;

            case 15:
              _context4.t3 = _context4.t4;

            case 16:
              _context4.t5 = _context4.t3;
              _context4.t6 = maxTimestamp;

              if (_context4.t6) {
                _context4.next = 27;
                break;
              }

              if (!maxBlock) {
                _context4.next = 25;
                break;
              }

              _context4.next = 22;
              return blockToTimestamp(maxBlock);

            case 22:
              _context4.t7 = _context4.sent;
              _context4.next = 26;
              break;

            case 25:
              _context4.t7 = undefined;

            case 26:
              _context4.t6 = _context4.t7;

            case 27:
              _context4.t8 = _context4.t6;
              _context4.t9 = {
                pair: _context4.t2,
                date_gte: _context4.t5,
                date_lte: _context4.t8
              };
              _context4.t10 = {
                orderDirection: 'desc',
                where: _context4.t9
              };
              _context4.t11 = _pairs.propertiesDayData;
              _context4.t12 = {
                entity: 'pairDayDatas',
                selection: _context4.t10,
                properties: _context4.t11
              };
              _context4.t13 = {
                api: _context4.t1,
                query: _context4.t12
              };
              return _context4.abrupt("return", (0, _context4.t0)(_context4.t13).then(function (results) {
                return _pairs.callbackDayData(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 34:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  observePair: function observePair(_ref5) {
    var _ref5$pair_address = _ref5.pair_address,
        pair_address = _ref5$pair_address === void 0 ? undefined : _ref5$pair_address;

    if (!pair_address) {
      throw new Error("sushi-data: Pair address undefined");
    }

    var query = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            subscription {\n                pair(id: \"", "\") {\n                    ", "\n                }\n            }"])), pair_address.toLowerCase(), _pairs.properties.toString());
    var client = new SubscriptionClient(graphWSEndpoints.exchange, {
      reconnect: true
    }, ws);
    var observable = client.request({
      query: query
    });
    return {
      subscribe: function subscribe(_ref6) {
        var _next = _ref6.next,
            error = _ref6.error,
            complete = _ref6.complete;
        return observable.subscribe({
          next: function next(results) {
            _next(_pairs.callback([results.data.pair])[0]);
          },
          error: error,
          complete: complete
        });
      }
    };
  },
  pairs: function pairs() {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _ref7, _ref7$block, block, _ref7$timestamp, timestamp, _ref7$max, max, _ref7$pair_addresses, pair_addresses, query, result;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref7 = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {}, _ref7$block = _ref7.block, block = _ref7$block === void 0 ? undefined : _ref7$block, _ref7$timestamp = _ref7.timestamp, timestamp = _ref7$timestamp === void 0 ? undefined : _ref7$timestamp, _ref7$max = _ref7.max, max = _ref7$max === void 0 ? undefined : _ref7$max, _ref7$pair_addresses = _ref7.pair_addresses, pair_addresses = _ref7$pair_addresses === void 0 ? undefined : _ref7$pair_addresses;

              if (!pair_addresses) {
                _context5.next = 23;
                break;
              }

              if (!block) {
                _context5.next = 6;
                break;
              }

              _context5.t0 = block;
              _context5.next = 14;
              break;

            case 6:
              if (!timestamp) {
                _context5.next = 12;
                break;
              }

              _context5.next = 9;
              return timestampToBlock(timestamp);

            case 9:
              _context5.t1 = _context5.sent;
              _context5.next = 13;
              break;

            case 12:
              _context5.t1 = undefined;

            case 13:
              _context5.t0 = _context5.t1;

            case 14:
              block = _context5.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              query = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["{\n                    ", "\n                }"])), pair_addresses.map(function (pair, i) {
                return "\n                        pair".concat(i, ": pair(id: \"").concat(pair.toLowerCase(), "\", ").concat(block, ") {\n                            ").concat(_pairs.properties.toString(), "\n                    }");
              }));
              _context5.t2 = Object;
              _context5.next = 20;
              return request(graphAPIEndpoints.exchange, query);

            case 20:
              _context5.t3 = _context5.sent;
              result = _context5.t2.values.call(_context5.t2, _context5.t3);
              return _context5.abrupt("return", _pairs.callback(result));

            case 23:
              _context5.t4 = pageResults;
              _context5.t5 = graphAPIEndpoints.exchange;

              if (!block) {
                _context5.next = 29;
                break;
              }

              _context5.t6 = {
                number: block
              };
              _context5.next = 38;
              break;

            case 29:
              if (!timestamp) {
                _context5.next = 36;
                break;
              }

              _context5.next = 32;
              return timestampToBlock(timestamp);

            case 32:
              _context5.t8 = _context5.sent;
              _context5.t7 = {
                number: _context5.t8
              };
              _context5.next = 37;
              break;

            case 36:
              _context5.t7 = undefined;

            case 37:
              _context5.t6 = _context5.t7;

            case 38:
              _context5.t9 = _context5.t6;
              _context5.t10 = {
                block: _context5.t9
              };
              _context5.t11 = _pairs.properties;
              _context5.t12 = {
                entity: 'pairs',
                selection: _context5.t10,
                properties: _context5.t11
              };
              _context5.t13 = max;
              _context5.t14 = {
                api: _context5.t5,
                query: _context5.t12,
                max: _context5.t13
              };
              return _context5.abrupt("return", (0, _context5.t4)(_context5.t14).then(function (results) {
                return _pairs.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 45:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  pairs24h: function pairs24h() {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _ref8, _ref8$block, block, _ref8$timestamp, timestamp, _ref8$max, max, timestampNow, results, results24ago, results48ago, ethPriceUSD, ethPriceUSD24ago;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _ref8 = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {}, _ref8$block = _ref8.block, block = _ref8$block === void 0 ? undefined : _ref8$block, _ref8$timestamp = _ref8.timestamp, timestamp = _ref8$timestamp === void 0 ? undefined : _ref8$timestamp, _ref8$max = _ref8.max, max = _ref8$max === void 0 ? undefined : _ref8$max;

              if (!timestamp) {
                _context6.next = 5;
                break;
              }

              _context6.t0 = timestamp;
              _context6.next = 13;
              break;

            case 5:
              if (!block) {
                _context6.next = 11;
                break;
              }

              _context6.next = 8;
              return blockToTimestamp(block);

            case 8:
              _context6.t1 = _context6.sent;
              _context6.next = 12;
              break;

            case 11:
              _context6.t1 = Math.floor(Date.now() / 1000);

            case 12:
              _context6.t0 = _context6.t1;

            case 13:
              timestampNow = _context6.t0;
              timestamp24ago = timestampNow - TWENTY_FOUR_HOURS;
              timestamp48ago = timestamp24ago - TWENTY_FOUR_HOURS;

              if (!timestamp) {
                _context6.next = 22;
                break;
              }

              _context6.next = 19;
              return timestampToBlock(timestamp);

            case 19:
              _context6.t2 = _context6.sent;
              _context6.next = 23;
              break;

            case 22:
              _context6.t2 = block;

            case 23:
              block = _context6.t2;
              _context6.next = 26;
              return timestampToBlock(timestamp24ago);

            case 26:
              block24ago = _context6.sent;
              _context6.next = 29;
              return timestampToBlock(timestamp48ago);

            case 29:
              block48ago = _context6.sent;
              _context6.next = 32;
              return module.exports.pairs({
                block: block,
                max: max
              });

            case 32:
              results = _context6.sent;
              _context6.next = 35;
              return module.exports.pairs({
                block: block24ago,
                max: max
              });

            case 35:
              results24ago = _context6.sent;
              _context6.next = 38;
              return module.exports.pairs({
                block: block48ago,
                max: max
              });

            case 38:
              results48ago = _context6.sent;
              _context6.next = 41;
              return ethPrice({
                block: block
              });

            case 41:
              ethPriceUSD = _context6.sent;
              _context6.next = 44;
              return ethPrice({
                block: block24ago
              });

            case 44:
              ethPriceUSD24ago = _context6.sent;
              return _context6.abrupt("return", _pairs.callback24h(results, results24ago, results48ago, ethPriceUSD, ethPriceUSD24ago));

            case 46:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  observePairs: function observePairs() {
    var query = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            subscription {\n                pairs(first: 1000, orderBy: reserveUSD, orderDirection: desc) {\n                    ", "\n                }\n        }"])), _pairs.properties.toString());
    var client = new SubscriptionClient(graphWSEndpoints.exchange, {
      reconnect: true
    }, ws);
    var observable = client.request({
      query: query
    });
    return {
      subscribe: function subscribe(_ref9) {
        var _next2 = _ref9.next,
            error = _ref9.error,
            complete = _ref9.complete;
        return observable.subscribe({
          next: function next(results) {
            _next2(_pairs.callback(results.data.pairs));
          },
          error: error,
          complete: complete
        });
      }
    };
  }
};
var _pairs = {
  properties: ['id', 'token0 { id, name, symbol, totalSupply, derivedETH }', 'token1 { id, name, symbol, totalSupply, derivedETH }', 'reserve0', 'reserve1', 'totalSupply', 'reserveETH', 'reserveUSD', 'trackedReserveETH', 'token0Price', 'token1Price', 'volumeToken0', 'volumeToken1', 'volumeUSD', 'untrackedVolumeUSD', 'txCount'],
  callback: function callback(results) {
    return results.map(function (result) {
      return {
        id: result.id,
        token0: {
          id: result.token0.id,
          name: result.token0.name,
          symbol: result.token0.symbol,
          totalSupply: Number(result.token0.totalSupply),
          derivedETH: Number(result.token0.derivedETH)
        },
        token1: {
          id: result.token1.id,
          name: result.token1.name,
          symbol: result.token1.symbol,
          totalSupply: Number(result.token1.totalSupply),
          derivedETH: Number(result.token1.derivedETH)
        },
        reserve0: Number(result.reserve0),
        reserve1: Number(result.reserve1),
        totalSupply: Number(result.totalSupply),
        reserveETH: Number(result.reserveETH),
        reserveUSD: Number(result.reserveUSD),
        trackedReserveETH: Number(result.trackedReserveETH),
        token0Price: Number(result.token0Price),
        token1Price: Number(result.token1Price),
        volumeToken0: Number(result.volumeToken0),
        volumeToken1: Number(result.volumeToken1),
        volumeUSD: Number(result.volumeUSD),
        untrackedVolumeUSD: Number(result.untrackedVolumeUSD),
        txCount: Number(result.txCount)
      };
    }).sort(function (a, b) {
      return b.reserveUSD - a.reserveUSD;
    });
  },
  callback24h: function callback24h(results, results24h, results48h, ethPriceUSD, ethPriceUSD24ago) {
    return results.map(function (result) {
      var result24h = results24h.find(function (e) {
        return e.id === result.id;
      }) || result;
      var result48h = results48h.find(function (e) {
        return e.id === result.id;
      }) || result;
      return _objectSpread(_objectSpread({}, result), {}, {
        trackedReserveUSD: result.trackedReserveETH * ethPriceUSD,
        trackedReserveUSDChange: result.trackedReserveETH * ethPriceUSD / (result24h.trackedReserveETH * ethPriceUSD24ago) * 100 - 100,
        trackedReserveUSDChangeCount: result.trackedReserveETH * ethPriceUSD - result24h.trackedReserveETH * ethPriceUSD24ago,
        trackedReserveETHChange: result.trackedReserveETH / result24h.trackedReserveETH * 100 - 100,
        trackedReserveETHChangeCount: result.trackedReserveETH - result24h.trackedReserveETH,
        volumeUSDOneDay: result.volumeUSD - result24h.volumeUSD,
        volumeUSDChange: (result.volumeUSD - result24h.volumeUSD) / (result24h.volumeUSD - result48h.volumeUSD) * 100 - 100,
        volumeUSDChangeCount: result.volumeUSD - result24h.volumeUSD - (result24h.volumeUSD - result48h.volumeUSD),
        untrackedVolumeUSDOneDay: result.untrackedVolumeUSD - result24h.untrackedVolumeUSD,
        untrackedVolumeUSDChange: (result.untrackedVolumeUSD - result24h.untrackedVolumeUSD) / (result24h.untrackedVolumeUSD - result48h.untrackedVolumeUSD) * 100 - 100,
        untrackedVolumeUSDChangeCount: result.untrackedVolumeUSD - result24h.untrackedVolumeUSD - (result24h.untrackedVolumeUSD - result48h.untrackedVolumeUSD),
        txCountOneDay: result.txCount - result24h.txCount,
        txCountChange: (result.txCount - result24h.txCount) / (result24h.txCount - result48h.txCount) * 100 - 100,
        txCountChangeCount: result.txCount - result24h.txCount - (result24h.txCount - result48h.txCount)
      });
    });
  },
  callbackHourData: function callbackHourData(results) {
    return results.map(function (result) {
      return {
        id: result.id,
        token0: {
          id: result.token0.id,
          name: result.token0.name,
          symbol: result.token0.symbol,
          totalSupply: Number(result.token0.totalSupply),
          derivedETH: Number(result.token0.derivedETH)
        },
        token1: {
          id: result.token1.id,
          name: result.token1.name,
          symbol: result.token1.symbol,
          totalSupply: Number(result.token1.totalSupply),
          derivedETH: Number(result.token1.derivedETH)
        },
        reserve0: Number(result.reserve0),
        reserve1: Number(result.reserve1),
        totalSupply: Number(result.totalSupply),
        reserveETH: Number(result.reserveETH),
        reserveUSD: Number(result.reserveUSD),
        trackedReserveETH: Number(result.trackedReserveETH),
        token0Price: Number(result.token0Price),
        token1Price: Number(result.token1Price),
        volumeToken0: Number(result.volumeToken0),
        volumeToken1: Number(result.volumeToken1),
        volumeUSD: Number(result.volumeUSD),
        untrackedVolumeUSD: Number(result.untrackedVolumeUSD),
        txCount: Number(result.txCount),
        timestamp: result.timestamp
      };
    });
  },
  propertiesDayData: ['id', 'date', 'volumeUSD', 'volumeToken0', 'volumeToken1', 'reserveUSD', 'txCount'],
  callbackDayData: function callbackDayData(results) {
    return results.map(function (result) {
      return {
        id: result.id,
        date: new Date(result.date * 1000),
        timestamp: Number(result.date),
        volumeUSD: Number(result.volumeUSD),
        volumeToken0: Number(result.volumeToken0),
        volumeToken1: Number(result.volumeToken1),
        liquidityUSD: Number(result.reserveUSD),
        txCount: Number(result.txCount)
      };
    });
  }
};